import { MedRecSwitch, SearchHeader, StoreLocator } from '@/components';

import {
  HeaderFavorites,
  HeaderLogo,
  HeaderNav,
  HeaderProfile,
  HeaderRow,
  HeaderSection,
  HeaderShopping,
} from '../../Header.components';

const HeaderWithCenteredLogoAndLocatorDesktop = () => (
  <>
    <HeaderRow borderless type="small">
      <HeaderSection justify="center">
        <StoreLocator />
        <MedRecSwitch />
      </HeaderSection>
    </HeaderRow>
    <HeaderRow type="small">
      <HeaderSection justify="start">
        <HeaderNav />
      </HeaderSection>
      <HeaderSection justify="center">
        <HeaderLogo center fixHeight fullWidth />
      </HeaderSection>
      <HeaderSection justify="end">
        <SearchHeader withEmbeddedInput />
        <HeaderProfile />
        <HeaderFavorites />
        <HeaderShopping />
      </HeaderSection>
    </HeaderRow>
  </>
);

export { HeaderWithCenteredLogoAndLocatorDesktop };
